export const NOT_AVAILABLE = 'NOT_AVAILABLE';
